import { Controller } from "@hotwired/stimulus"

// Generic client-side list filter for admin tables. Typing hides any item whose
// searchable text doesn't contain the query. Each item supplies its searchable
// text via data-filter-text (falling back to the item's text content). Debounced
// so we only re-filter once the user pauses typing.
export default class extends Controller {
  static targets = ["input", "item"]
  static values = { delay: { type: Number, default: 300 } }

  filter() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this.#apply(), this.delayValue)
  }

  #apply() {
    const query = this.inputTarget.value.trim().toLowerCase()
    this.itemTargets.forEach(item => {
      const haystack = (item.dataset.filterText ?? item.textContent).toLowerCase()
      item.classList.toggle("hidden", !haystack.includes(query))
    })
  }
}
